// 2020-06-27export { TropaComponent } from './tropa.component';